<template>
  <IconLucideQrCode />
</template>
